/* 
 * ToggleButton.js
 * Created on 8-dec-2016
 * @author Swen Meeuwes for &ranj
 */

import ToggleButtonEvent from "./ToggleButtonEvent";

export default class ToggleButton {
    constructor(domElement) {
        createjs.EventDispatcher.initialize(this);
        this._domElement = domElement;
        this._isToggled = false;
        this.initialize();
    }

    initialize() {
        this._createIndicator();
        this._handleButtonBound = this._handleButton.bind(this);
        this._domElement.addEventListener("click", this._handleButtonBound);
    }

    destroy() {
        this._domElement.removeEventListener("click", this._handleButtonBound);
    }

    setToggleState(newToggleState) {
        this._isToggled = newToggleState;
        this._updateIndicator();
    }

    isToggled() {
        return this._isToggled;
    }

    _createIndicator() {
        const indicator = this._domElement.ownerDocument.createElement("SPAN");
        this._domElement.stateIndicator = indicator;
        this._updateIndicator();
        this._domElement.appendChild(indicator);
    }

    _updateIndicator() {
        const indicator = this._domElement.stateIndicator;
        if (this._isToggled) {
            indicator.className = "toggleIndicator toggleOn";
            indicator.innerText = "On";
        } else {
            indicator.className = "toggleIndicator toggleOff";
            indicator.innerText = "Off";
        }
    }

    _handleButton() {
        this._isToggled ? this._isToggled = false : this._isToggled = true;
        this._updateIndicator();
        this.dispatchEvent(ToggleButtonEvent.CLICK);
    }
}


